import React from 'react'
import styles from './InitialPage.module.scss'
import documents from '../../image/InitialPage/require-title.png'
import Offers from '../../components/Offers/Offers'


const InitialPage = ({isOpen}) => {
    return (
        <section className={styles.main} id='initial'>
            <div className={styles.container}>
                <p className={styles.text}>Вам нужна помощь для легальной работы ВКС?</p>
                <h1 className={styles.title}><span>Юридические услуги</span>  Помощь в оформлении разрешений на работу иностранным гражданам</h1>
                <div className={styles.box}>
                    <img className={styles.documents} src={documents} alt='документы'/>
                    <p className={styles.subtitle}>ВКС, Квотовые и внеквотовые должности. Гарантируем 100% законность и отсутствие любых рисков</p>
                </div>
                <Offers/>
                <p className={styles.text_gray}><span>Получите бесплатную развернутую консультацию</span> по вашему вопросу в течение 15 минут</p>
                <div className={styles.box_button}>
                    <button className={styles.button} type='button' onClick={isOpen}>получить консультацию</button>
                </div>
            </div>
        </section>
    )
}

export default InitialPage